import { render, staticRenderFns } from "./DebugPage.vue?vue&type=template&id=51ceea70&scoped=true"
import script from "./DebugPage.vue?vue&type=script&lang=js"
export * from "./DebugPage.vue?vue&type=script&lang=js"
import style0 from "./DebugPage.vue?vue&type=style&index=0&id=51ceea70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ceea70",
  null
  
)

export default component.exports